import React from 'react';
import {
	View,
} from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

export const Heading = ({
	heading,
	subHeading,
	subHeadingIcon,
	onHeadingPress,
}) => {
	const styles = useThemedStyles(createStyles);
	return (
		<View style={styles.headingContainer}>
			<Text
				style={styles.heading}
				onPress={onHeadingPress}
				suppressHighlighting={true}
			>
				{heading}
			</Text>
			<View style={styles.subHeadingRow}>
				{subHeadingIcon}
				<Text style={styles.subHeading}>
					{subHeading}
				</Text>
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, type } }) => ({
	heading: {
		paddingTop: 16,
		...type.title,
		color: colors.text,
	},
	subHeadingRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 4,
		marginTop: 4,
	},
	subHeading: {
		...type.bodySmall,
		color: colors.textSecondary,
		// Text in a flex row never shrinks by default, so long subheadings would
		// overflow instead of wrapping when the heading sits beside other content.
		flexShrink: 1,
	},
	headingContainer: {
		marginBottom: 8,
	},
});

